var $18e4d1d5b500a9ee$exports = {};
$18e4d1d5b500a9ee$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03B1\u03C2 \u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD",
  "colorSwatch": "\u03C7\u03C1\u03C9\u03BC\u03B1\u03C4\u03B9\u03BA\u03CC \u03B4\u03B5\u03AF\u03B3\u03BC\u03B1",
  "transparent": "\u03B4\u03B9\u03B1\u03C6\u03B1\u03BD\u03AD\u03C2",
  "twoDimensionalSlider": "\u03A1\u03C5\u03B8\u03BC\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC 2D"
};
export { $18e4d1d5b500a9ee$exports as default };